module.exports = __webpack_public_path__ + "assets/mastercard.6743f5b9.svg";